import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiHelper from '../api/ApiHelper';
import { Article, Category } from './types/ArticleTypes';
import './styles/Posts.css';

const CategoryArticles: React.FC = () => {
    const [articles, setArticles] = useState<Article[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { category } = useParams<{ category: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCategoryArticles = async () => {
            if (!category) return;
            try {
                const data = await apiHelper.fetchArticlesByCategory(category);
                setArticles(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch articles for this category');
                setLoading(false);
            }
        };

        fetchCategoryArticles();
    }, [category]);

    const handleArticleClick = (articleId: string) => {
        navigate(`/article/${articleId}`);
    };

    if (loading) {
        return <div className="articles-list">Loading...</div>;
    }

    if (error) {
        return <div className="articles-list">{error}</div>;
    }

    return (
        <div className="articles-list">
            <h1 className="category-title">
                {category ? `${category.charAt(0).toUpperCase()}${category.slice(1)} Articles` : 'Category Articles'}
            </h1>
            {articles.length === 0 ? (
                <div>No articles found in this category</div>
            ) : (
                articles.map(item => (
                    <div 
                        key={item.articleId} 
                        className="article"
                        onClick={() => handleArticleClick(item.articleId)}
                    >
                        <div className="article-image-container">
                            <img src={item.mainImageUrl} alt={item.title} />
                        </div>
                        <div className="article-content-wrapper">
                            <div className="category-tag">
                                {Category[item.categoryName as keyof typeof Category]}
                            </div>
                            <h2 className="article-title">
                                {item.title}
                            </h2>
                            <div
                                className="article-description"
                                dangerouslySetInnerHTML={{ __html: item.description }}
                            />
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default CategoryArticles;